export enum ExcelType {
  TEXT = 'String',
  DATE = 'DateTime',
  NUMERICAL = 'Number',
}
